import { render, staticRenderFns } from "./CreateIDiagPage.vue?vue&type=template&id=7cd8d64d"
import script from "./CreateIDiagPage.js?vue&type=script&lang=js&external"
export * from "./CreateIDiagPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports